<template>
    <div class="page">
        <h1 class="text_13 vacancy__title">{{ this.$i18n.t("fill_form") }} {{ vacancyTitle }}</h1>
        <transition name="fade" mode="out-in">
            <div class="vacancy">
                <form class="vacancy__vacancy-form" v-if="!isSent">
                    <div class="vacancy-form__block">
                        <div class="vacancy-form__header">
                            <div class="vacancy-form__header-number text_11">
                                <span>1</span>
                            </div>
                            <span class="text_15 text_bold">{{ this.$i18n.t("personal_data") }}</span>
                        </div>
                        <div class="vacancy-form__content">
                            <div class="form-group">
                                <Input
                                    :type="'text'"
                                    :label="$t('city')"
                                    :name="'city'"
                                    :suggestion="true"
                                    :required="true"
                                    v-model="city.value"
                                    :validationMessage="city.validationMessage"
                                    :isValid="city.isValid" />
                            </div>
                            <div class="form-group">
                                <Input
                                    :type="'text'"
                                    :name="'name'"
                                    :label="this.$i18n.t('name')"
                                    :required="true"
                                    v-model="first_name.value"
                                    :validationMessage="first_name.validationMessage"
                                    :isValid="first_name.isValid" />
                                <Input
                                    :type="'text'"
                                    :name="'surname'"
                                    :label="this.$i18n.t('surname')"
                                    :required="true"
                                    v-model="last_name.value"
                                    :validationMessage="last_name.validationMessage"
                                    :isValid="last_name.isValid" />
                            </div>
                            <div class="form-group">
                                <Input
                                    :type="'text'"
                                    :name="'birthday'"
                                    :label="this.$i18n.t('birthdate')"
                                    :required="true"
                                    v-model="birthday.value"
                                    :validationMessage="birthday.validationMessage"
                                    :isValid="birthday.isValid"
                                    v-mask="'##.##.####'" />
                            </div>
                        </div>
                    </div>
                    <div class="vacancy-form__block">
                        <div class="vacancy-form__header">
                            <div class="vacancy-form__header-number text_11">
                                <span>2</span>
                            </div>
                            <span class="text_15 text_bold">{{ this.$i18n.t("contact_data") }}</span>
                        </div>
                        <div class="vacancy-form__content">
                            <div class="form-group">
                                <Input
                                    :type="'tel'"
                                    :name="'phone'"
                                    :label="this.$i18n.t('phone')"
                                    :required="true"
                                    v-model="phone.value"
                                    :validationMessage="phone.validationMessage"
                                    :isValid="phone.isValid" />
                            </div>
                            <div class="form-group">
                                <Input
                                    :type="'email'"
                                    :name="'email'"
                                    :label="this.$i18n.t('el_mail')"
                                    :required="true"
                                    v-model="email.value"
                                    :validationMessage="email.validationMessage"
                                    :isValid="email.isValid" />
                            </div>
                            <div class="form-group form-group--resume">
                                <Input
                                    :validationMessage="''"
                                    :type="'file'"
                                    :name="'resume-file'"
                                    :label="this.$i18n.t('attach_resume')"
                                    v-model="resume_file.value"
                                    :isFile="true"
                                    id="resume"
                                    accept=".doc,.docx,.pdf"
                                    :isValid="resume_file.isValid"
                                    ref="resumeFile" />
                                <span class="text_11 color-text_3">{{ this.$i18n.t("or") }}</span>
                                <Input
                                    :validationMessage="''"
                                    :type="'text'"
                                    :name="'resume-link'"
                                    :label="this.$i18n.t('resume_link')"
                                    v-model="resume_link.value"
                                    :isValid="resume_link.isValid" />
                            </div>
                        </div>
                    </div>
                    <div class="vacancy-form__block">
                        <div class="vacancy-form__header">
                            <div class="vacancy-form__header-number text_11">
                                <span>3</span>
                            </div>
                            <span class="text_15 text_bold">{{ this.$i18n.t("you_more") }}</span>
                        </div>
                        <div class="vacancy-form__content">
                            <div class="form-group">
                                <Input
                                    :type="'text'"
                                    :label="$t('you_any')"
                                    :name="'info'"
                                    v-model="additional_info.value"
                                    :isValid="additional_info.isValid" />
                            </div>
                            <div class="form-group">
                                <Input
                                    :type="'text'"
                                    :label="this.$i18n.t('where_find_vacancy')"
                                    :name="'from'"
                                    v-model="from.value"
                                    :isValid="from.isValid"
                                    :validationMessage="from.validationMessage"
                                    :required="true" />
                            </div>
                            <div class="form-group form-group--file">
                                <Input
                                    :isValid="photo.isValid"
                                    :validationMessage="''"
                                    :type="'file'"
                                    :name="'photo'"
                                    :label="this.$i18n.t('upload_photo')"
                                    v-model="photo.value"
                                    :isFile="true"
                                    :isImage="true"
                                    id="photo"
                                    accept="image/gif, image/jpeg, image/png"
                                    ref="photo" />
                            </div>
                        </div>
                    </div>
                    <div class="vacancy-form__block">
                        <div class="vacancy-form__content vacancy-form__content--submit">
                            <div class="button button--dark text_15 text_bold" @click="send">
                                {{ $t("send_form") }} <img v-lazy-load data-src="../../../assets/icons/arrow-right--thin.svg" />
                            </div>
                            <div class="text_9">
                                <span class="color-text_2">{{ $t("terms_register") }}</span>
                                <nuxt-link to="/dokumenty/soglashenie-ob-obrabotke-persnonalnyh-dannyh/">{{
                                    $t("terms_po_pp")
                                }}</nuxt-link>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="vacancy__vacancy-submit" v-else>
                    <h1>{{ $t("vacancy_submit") }}</h1>
                </div>
                <img v-lazy-load data-src="/img/vacancy.jpg" alt="Изображение вакансии" class="vacancy__vacancy-image" />
            </div>
        </transition>
    </div>
</template>

<script>
import Input from "../../../components/form/Input.vue";
import { mask } from "vue-the-mask";
export default {
    components: { Input },
    layout: "default",
    name: "Vacancy",
    directives: { mask },
    head() {
        return {
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.seo?.description ? this.seo.description : "",
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.seo?.description ? this.seo.description : "",
                },
                {
                    hid: "keywords",
                    property: "keywords",
                    content: this.seo?.keywords ? this.seo.keywords : "",
                },
            ],
        };
    },
    data() {
        return {
            isSent: false,
            vacancyTitle: this.$route.query.title,
            seo: {},
            city: {
                value: "",
                validationMessage: "",
                isValid: true,
            },
            first_name: {
                value: "",
                validationMessage: "",
                isValid: true,
            },
            last_name: {
                value: "",
                validationMessage: "",
                isValid: true,
            },
            birthday: {
                value: "",
                validationMessage: "",
                isValid: true,
            },
            phone: {
                value: "",
                validationMessage: "",
                isValid: true,
            },
            email: {
                value: "",
                validationMessage: "",
                isValid: true,
            },
            resume_file: {
                value: "",
                isValid: true,
            },
            resume_link: {
                value: "",
                isValid: true,
            },
            additional_info: {
                value: "",
                isValid: true,
            },
            from: {
                value: "",
                validationMessage: "",
                isValid: true,
            },
            photo: {
                value: "",
                isValid: true,
            },
        };
    },
    async asyncData({ $axios }) {
        const seo = await $axios.get("/api/seo/vacancies");
        return {
            seo: seo.data,
        };
    },
    computed: {
        crumbs() {
            return [
                { name: this.$i18n.t("vacancies"), url: "/vacancies" },
                {
                    name:
                        this.vacancyTitle.length > 15 ? this.vacancyTitle.substring(0, 13) + "..." : this.vacancyTitle,
                },
            ];
        },
    },
    methods: {
        async send() {
            try {
                const formData = new FormData();
                formData.append("vacancy", this.vacancyTitle);
                formData.append("city", this.city.value);
                formData.append("first_name", this.first_name.value);
                formData.append("last_name", this.last_name.value);
                formData.append("birthday", this.birthday.value);
                formData.append("phone", this.phone.value);
                formData.append("email", this.email.value);
                formData.append("resume_file", this.$refs.resumeFile.$el.querySelector("input").files[0]);
                formData.append("resume_link", this.resume_link.value);
                formData.append("additional_info", this.additional_info.value);
                formData.append("from", this.from.value);
                formData.append("photo", this.$refs.photo.$el.querySelector("input").files[0]);
                await this.$axios.post("/api/forms/vacancies/create", formData, {
                    "Content-Type": "multipart/form-data",
                });
                this.isSent = true;
                document.querySelector("html").scrollTop = 0;
            } catch (error) {
                let data = error.response.data.error;
                for (let key in data) {
                    this[key].validationMessage = data[key][0];
                    this[key].isValid = false;
                }
            }
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
    },
};
</script>

<style lang="less" scoped>
.vacancy {
    display: flex;
    background: #ffffff;
    &__title {
        position: fixed;
        z-index: 6;
        left: 50%;
        transform: translateX(-50%);
        top: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        .trs(transform);
        // @media @notsm {
        //     .is_scrolled & {
        //         transform: translate(-50%, -100%);
        //     }
        // }
        @media @sm {
            position: static;
            width: 100%;
            transform: none;
            justify-content: center;
            border-bottom: 1px solid @border2;
        }
    }
    &__vacancy-form,
    &__vacancy-submit,
    &__vacancy-image {
        width: 50%;
        @media (max-width: 850px) {
            width: 100%;
        }
    }
    &__vacancy-submit {
        padding: 40px 32px;
        font-size: 16px;
        text-align: center;
        line-height: 140%;
        letter-spacing: 1.76px;
    }
    &__vacancy-image {
        object-fit: cover;
        @media (max-width: 850px) {
            display: none;
        }
    }
    &-form {
        &__block {
            padding: 40px 32px;
            display: flex;
            flex-direction: column;
            gap: 24px;
        }
        &__content {
            display: flex;
            flex-direction: column;
            gap: 24px;
            &--submit {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 32px;
                .button {
                    width: 100%;
                    max-width: 358px;
                    height: 48px;
                    padding: 10px;
                    gap: 10px;
                    img {
                        filter: invert(100%) sepia(2%) saturate(7448%) hue-rotate(261deg) brightness(104%)
                            contrast(107%);
                    }
                    @media (max-width: 485px) {
                        font-size: 13px;
                        gap: 5px;
                        height: 60px;
                    }
                    @media (max-width: 425px) {
                        height: 70px;
                        flex-direction: column;
                    }
                }
            }
        }
        &__header {
            display: flex;
            align-items: center;
            &-number {
                margin-right: 16px;
                width: 26px;
                height: 26px;
                position: relative;
                color: #fff;
                display: flex;
                span {
                    margin: auto;
                    position: relative;
                    z-index: 1;
                    padding-left: 1px;
                }
                &:after {
                    content: "";
                    display: block;
                    width: 18px;
                    height: 18px;
                    transform: translate(-50%, -50%) rotate(45deg);
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    background: #000;
                }
            }
        }
    }
}
.form-group {
    height: 41px;
    &--resume {
        display: flex;
        gap: 31px;
        align-items: center;
        & > span {
            margin-top: 20px;
        }
        @media (max-width: 425px) {
            flex-direction: column;
            gap: 0;
            height: 130px;
            & > span {
                margin-top: 30px;
            }
        }
    }
    &--file {
        height: 160px;
    }
}
</style>
